/*
Todo: implementare onChange nella superSelect
Note di funzionamento:
type compila policy, premium, amount
policy compila premium, amount
premium e amount dipendono da financialDataAccordionCtrl.financialData.durationPriceList chiamato come financialDataAccordionCtrl.amount
*/
(function () {
  "use strict";

  angular.module("assurance.components", []).component("assurance", {
    templateUrl: "ng/components/assurance/assurance.view.html",
    bindings: {
      onAssuranceChange: "&?",
      onAssuranceOk: "&?",
      onAssuranceNotOk: "&?",
      maxPicks: "<?",
      assurance: "="
    },
    controllerAs: "assuranceCtrl",
    controller: AssuranceController
  });

  function AssuranceController(Assurance) {
    var self = this;

    self.assuranceRow = Assurance.build();
    self.assuranceExt = {
      typeInputData: [{
          item: "Assurance 1"
        },
        {
          item: "Assurance 2"
        },
        {
          item: "Assurance 3"
        }
      ],
      typePicks: [],
      policyInputData: [{
          item: "Policy 1"
        },
        {
          item: "Policy 2"
        },
        {
          item: "Policy 3"
        }
      ],
      policyPicks: []
    };

    self.$onInit = function () {
      self.onAssuranceChange = self.onAssuranceChange || function () {};
      self.onAssuranceOk = self.onAssuranceOk || function () {};
      self.onAssuranceNotOk = self.onAssuranceNotOk || function () {};
      self.maxPicks = self.maxPicks || 5;
      self.assurance = self.assurance || []; // Assurance.build()
      self.change('$onInit');
    };

    self.addItem = function (s) {
      self.assurance[self.assurance.length] = Assurance.build({
        type: self.assuranceRow.type,
        policy: self.assuranceRow.policy,
        premium: self.assuranceRow.premium,
        amount: self.assuranceRow.amount
      });
      self.change('addItem');
    };

    self.removeItem = function (i) {
      self.assurance.splice(i, 1);
      self.change('removeItem');
    };

    self.change = function () { // validityCheck
      // Used for each field change
      var isValid = true;
      if (self.assurance.length) {
        self.assurance.forEach(function (data, i, a) {
          if (!(
              data.type &&
              data.policy &&
              data.premium &&
              data.amount
            )) {
            isValid = false;
          }
        });
      } else {
        isValid = false;
      };
      if (isValid) {
        self.onAssuranceOk();
      } else {
        self.onAssuranceNotOk();
      }
    };

    self.onChange = function (s) {
      self.onAssuranceChange();
    }

    self.$onChanges = function (e) {
      //console.log('Test - assurance - $onChanges');
    }
  }
})();